export const GET_ALL_ETEMPLATES = 'GET_ALL_ETEMPLATES';
export const GET_SINGLE_ETEMPLATE = "GET_SINGLE_ETEMPLATE";
export const UPDATE_ETEMPLATE_REQUEST = "UPDATE_ETEMPLATE_REQUEST";
export const UPDATE_ETEMPLATE_SUCCESS = "UPDATE_ETEMPLATE_SUCCESS";
export const UPDATE_ETEMPLATE_RESET = "UPDATE_ETEMPLATE_RESET";
export const UPDATE_ETEMPLATE_FAILED = "UPDATE_ETEMPLATE_FAILED";

export const CLEAR_ERRORS = 'CLEAR_ERRORS';